/** Utilitaires partagés */

/** Concatène des classes CSS en filtrant les valeurs falsy */
export function cn(...classes: (string | false | null | undefined)[]): string {
  return classes.filter(Boolean).join(' ');
}

/** Parse une date ISO en la considérant UTC si aucune timezone n'est indiquée.
 *
 * Les timestamps en base sont stockés sans timezone mais correspondent à UTC
 * (alimenté par `datetime.now(timezone.utc)` côté back). Un simple
 * `new Date(iso)` les interprète en heure locale → décalage visible.
 */
export function parseServerDate(iso: string): Date {
  if (/Z$|[+-]\d{2}:?\d{2}$/.test(iso)) return new Date(iso);
  return new Date(iso + 'Z');
}

/** Formate une date ISO en format français court (ex: 08/04/2026) */
export function formatDate(iso: string): string {
  return parseServerDate(iso).toLocaleDateString('fr-FR');
}

/** Formate une date ISO en heure française (ex: 08:32) */
export function formatTime(iso: string): string {
  return parseServerDate(iso).toLocaleTimeString('fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Formate un delta d'heures avec signe (ex: +1.5, -2.0) */
export function formatDelta(hours: number): string {
  const sign = hours >= 0 ? '+' : '';
  return `${sign}${hours.toFixed(1)}h`;
}
